import { history } from 'ice';

import styles from './MobileLayout.module.scss';

export const getMobileLayoutClassName = (
  canActiveScreenStandby: boolean,
  isStandby: boolean
) => {
  const currentPath = history.location.pathname;
  const isHome = currentPath === '/mobile/home';
  if (isHome) {
    return canActiveScreenStandby && isStandby
      ? [styles.MobileLayout, styles.hideMobileLayout]
      : styles.MobileLayout;
  } else {
    return canActiveScreenStandby && isStandby
      ? [styles.MobileLayout2, styles.hideMobileLayout]
      : styles.MobileLayout2;
  }
};
